import { OktaAuthOptions } from "@okta/okta-auth-js";
import { AppSettings } from "../AppSettings";

export const oktaAuthConfig: OktaAuthOptions = {
    issuer: AppSettings.issuer,
    clientId: AppSettings.clientId,
    redirectUri: `${window.location.origin}/ui/login/callback`,
    scopes: ["openid", "email", "profile", "groups"],
};
